 /*=========================================================================================
  File Name: mutations.js
  Description: Restaurants State Module
  ----------------------------------------------------------------------------------------
  Item Name: Fuji Sushi App
  Author: Tan Tran
==========================================================================================*/
import moment from 'moment';

export default {
    SET_RESTAURANTS_STATE (state, payload) {
        state.restaurants = payload;
    },
     
    SET_CURRENT_RESTAURANT_STATE (state, payload) {
        console.log("SET_CURRENT_RESTAURANT_STATE")
        console.log(payload)
        state.currentRestaurantId = payload.restaurantId;
    },

    SET_CURRENT_WAITING_TIME_STATE (state, payload) {
        state.currentWaitingTime = payload;
        let ranges = [];
        let i = state.currentWaitingTime;
        let time = 60;

        while (i <= time) {
            let o = {
                'value' : i,
                'text' : i + ' minutter'
            }
            ranges.push(o);
            i += 5;

        }

        state.waitingTimeRanges = ranges;
        
    },

    SET_CURRENT_LOCAL_TIME_STATE (state, payload) {
        state.currentLocalTime = payload;
        //console.log(state.currentLocalTime)
        let fromTime = moment(state.restaurants[state.currentRestaurantId].fromTime, 'HH:mm:ss').hours();
        let toTime = moment(state.restaurants[state.currentRestaurantId].toTime, 'HH:mm:ss').hours();
        let currentTime = moment(state.currentLocalTime, 'HH:mm:ss').hours();

        if(fromTime < currentTime) {
            fromTime = currentTime
        }

        for (var i = 0; i < fromTime + 1; i++) {
            state.disabledHours.push(i);
        }

        for (var j = toTime; j < 24; j++) {
            state.disabledHours.push(j);
        }

    },

    
}